var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShoppingCartSolid = function SvgShoppingCartSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#shopping-cart-solid_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    filter: "url(#shopping-cart-solid_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.7 1.225C.7.935.935.7 1.225.7h1.14c.612 0 1.13.451 1.213 1.058l.048.342c3.205.009 6.334.35 9.352.989.28.059.46.331.407.612a34 34 0 0 1-1.134 4.34.525.525 0 0 1-.498.359H4.2q-.12 0-.235.016a1.75 1.75 0 0 0-1.37 1.034h9.48a.525.525 0 0 1 0 1.05H1.932a.525.525 0 0 1-.524-.565 2.8 2.8 0 0 1 1.902-2.44L2.538 1.9a.175.175 0 0 0-.173-.151h-1.14A.525.525 0 0 1 .7 1.225M4.2 12.25a1.05 1.05 0 1 1-2.1 0 1.05 1.05 0 0 1 2.1 0M10.85 13.3a1.05 1.05 0 1 0 0-2.1 1.05 1.05 0 0 0 0 2.1"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "shopping-cart-solid_svg__a",
    width: 14,
    height: 14.5,
    x: 0,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_489_4369"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_489_4369",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "shopping-cart-solid_svg__b",
    width: 12.694,
    height: 13.1,
    x: 0.7,
    y: 0.7,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_489_4369"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_489_4369",
    result: "shape"
  })))));
};
export default SvgShoppingCartSolid;